import {
  CheckCircle2,
  Edit3,
  MoreHorizontal,
  Power,
  Trash2,
  XCircle,
} from "lucide-react";

import { Button } from "@/components/ui/button";

import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuSeparator,
  DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu";
import type { TransactionTierSetting } from "@/interfaces/transaction-tier-settings";

interface TransactionSettingActionsProps {
  setting: TransactionTierSetting;
  onEdit: () => void;
  onToggle: () => void;
  onDelete: () => void;
  isToggling?: boolean;
}

export function TransactionSettingActions({
  setting,
  onEdit,
  onToggle,
  onDelete,
  isToggling = false,
}: TransactionSettingActionsProps) {
  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button
          type="button"
          variant="ghost"
          size="icon"
          className="h-8 w-8 text-slate-400 hover:bg-slate-800 hover:text-white"
        >
          <MoreHorizontal className="h-4 w-4" />
          <span className="sr-only">Open policy actions</span>
        </Button>
      </DropdownMenuTrigger>

      <DropdownMenuContent
        align="end"
        className="w-48 border-slate-700 bg-slate-900 text-slate-200"
      >
        <DropdownMenuItem
          onClick={onEdit}
          className="cursor-pointer focus:bg-slate-800 focus:text-white"
        >
          <Edit3 className="mr-2 h-4 w-4 text-slate-400" />
          Edit policy
        </DropdownMenuItem>

        <DropdownMenuItem
          onClick={onToggle}
          disabled={isToggling}
          className="cursor-pointer focus:bg-slate-800 focus:text-white"
        >
          {setting.enabled ? (
            <>
              <XCircle className="mr-2 h-4 w-4 text-amber-400" />
              Disable policy
            </>
          ) : (
            <>
              <CheckCircle2 className="mr-2 h-4 w-4 text-emerald-400" />
              Enable policy
            </>
          )}
        </DropdownMenuItem>

        <DropdownMenuSeparator className="bg-slate-800" />

        <DropdownMenuItem
          onClick={onDelete}
          className="cursor-pointer text-red-400 focus:bg-red-500/10 focus:text-red-400"
        >
          <Trash2 className="mr-2 h-4 w-4" />
          Delete policy
        </DropdownMenuItem>
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
